import { NavLink } from "react-router";

function LeftMenu() {
    return (
        <>
            <div className="menu_content d-flex flex-column align-items-center justify-content-center text-center">
                {/* <div id="close-left-menu" className="menu_close_container" onClick={closeNav}><div className="menu_close"></div></div> */}
                <ul id="left-menu-item" className="list-unstyled text-left mt-5">
                    <li className="menu_item"><NavLink to="/">Home</NavLink></li>
                    <li className="menu_item"><NavLink to="/about">About IETEC</NavLink></li>
                    <li className="menu_item"><NavLink to="/call-for-papers">Call for Papers</NavLink></li>
                    <li className="menu_item"><NavLink to="/masterclasses-workshops">Masterclasses/Workshops</NavLink></li>
                    {/* <li className="menu_item"><NavLink to="/registration">Registration</NavLink></li> */}
                    <li className="menu_item"><NavLink to="/sponsorship-exhibition">Sponsorship and Exhibition</NavLink></li>
                    <li className="menu_item"><NavLink to="/venue-accommodation">Venue and Accommodation</NavLink></li>
                    <li className="menu_item"><NavLink to="/program-outline">Program Outline</NavLink></li>
                    {/* <li className="menu_item"><NavLink to="/committee">Organising Committee</NavLink></li> */}
                    <li className="menu_item"><NavLink to="/contact-us">Contact Us</NavLink></li>
                </ul>
            </div>
        </>
    )
}

function closeNav() {
	document.getElementById("mySidenav").style.width = "0";
}

export default LeftMenu